import api from '@/logic/api'

export default {
  getFormAnswerByRelatable: (foreignType, foreignId) => api.get(`/forms/${foreignType}/${foreignId}/answer`),
}
